import { render, staticRenderFns } from "./ToggleTab.vue?vue&type=template&id=60ef7708&scoped=true&"
import script from "./ToggleTab.vue?vue&type=script&lang=js&"
export * from "./ToggleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef7708",
  null
  
)

export default component.exports